
// Routes
export const R_DEMO               = '/demo';
export const R_DISPLAY            = '/display';


// Namings
export const N_GENERAL_ERROR                = 'خطا در پردازش رخ داد.';
export const N_FETCH_ERROR                  = 'خطا در دریافت اطلاعات رخ داد.';
export const N_SITE_TITLE                   = 'هاله';

